import { useLocation } from "react-router-dom";
import { Table } from "../../features/Table";
import { type TimeSeries, time_series_columns } from "./columns";
import { FilterTimeSeries } from "./filter";

const client = "instit-quantilia";
const table_name = "time_series";

export const TimeSeriesTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<TimeSeries, TimeSeries>
      label="Time Series"
      client={client}
      table_name={table_name}
      columns={time_series_columns}
      filter={<FilterTimeSeries />}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
